import React from 'react';
import ServiceDetailPage from '../ServiceDetailPage';

const vipConfig = {
  pageClass: 'vip-detail-page',
  eyebrow: 'VIP resources',
  title: 'VIP resources in Telegram.',
  copy: 'A tighter stream for traders who already like the free channel: market notes, signal context, proof previews, and member discussion without pretending risk disappears.',
  actions: [
    { label: 'Join VIP', to: '/services/vip/payment' },
    { label: 'View Results', to: '/results', variant: 'secondary' },
    { label: 'Free Telegram', href: 'https://t.me/cryptoxnfts', variant: 'ghost' },
  ],
  metrics: [
    {
      value: <span className="vip-sale-price"><s className="vip-sale-price__original">1,159 USDT</s><span>578 USDT</span><span className="vip-sale-price__badge">50% OFF</span></span>,
      label: 'VIP access',
      note: 'Save 581 USDT · Manual redemption',
    },
    { value: 'Telegram', label: 'Delivery', note: 'Signals and notes' },
    { value: 'Proof', label: 'Examples visible', note: 'Historical only' },
  ],
  visual: {
    kicker: 'VIP DESK',
    badge: 'SIGNALS',
    label: 'VIP Telegram preview',
    rows: [
      { label: 'BTC plan', title: 'Levels marked', meta: '4H' },
      { label: 'ETH watch', title: 'Trigger mapped', meta: '1D' },
      { label: 'SOL note', title: 'Risk first', meta: 'Live' },
    ],
    chips: ['Chart posted', 'Entry trigger', 'Invalidation', 'Proof archive'],
    media: {
      src: '/assets/images/services/vip/pnl1.png',
      alt: 'Historical VIP result preview',
      label: 'Historical VIP example',
    },
  },
  featuresIntro: {
    eyebrow: 'What changes after free',
    title: 'More structure, fewer scattered decisions.',
    copy: 'VIP is for users who want a tighter resource stream after they already understand the CRYPTOXNFT style.',
  },
  features: [
    {
      label: 'Signals',
      title: 'Setup context',
      copy: 'Entries, levels, invalidation notes, and the reasoning behind the trade idea.',
    },
    {
      label: 'Discussion',
      title: 'Member channel',
      copy: 'A focused place to ask about setups, risk, and current market conditions.',
    },
    {
      label: 'Archive',
      title: 'Proof previews',
      copy: 'Historical screenshots stay visible so users can judge the style before upgrading.',
    },
  ],
  flowIntro: {
    eyebrow: 'How access works',
    title: 'Pay only after the fit is clear.',
    copy: 'The VIP route stays direct: review the offer, use the official payment page, then send proof for manual access review.',
  },
  steps: [
    {
      title: 'Review the offer',
      copy: 'Confirm VIP matches the way you want market notes and signal context delivered.',
    },
    {
      title: 'Use the payment page',
      copy: 'Choose the supported currency and send payment through the official route.',
    },
    {
      title: 'Send proof',
      copy: 'Share the payment screenshot with Telegram admin for manual activation.',
    },
  ],
  proofIntro: {
    eyebrow: 'Proof style',
    title: 'Examples stay visible before the purchase.',
    copy: 'These assets are preserved as historical context so users can understand the presentation style.',
  },
  proofItems: [
    {
      src: '/assets/images/services/vip/pnl1.png',
      alt: 'Historical VIP PNL screenshot',
      label: 'Historical example',
    },
    {
      src: '/assets/images/services/vip/pnl2.png',
      alt: 'VIP result preview screenshot',
      label: 'Result preview',
    },
    {
      src: '/assets/images/services/vip/pnl3.png',
      alt: 'Historical VIP result screenshot',
      label: 'Archive preview',
    },
  ],
  notice: 'Trading involves risk. VIP resources can include trade ideas and commentary, but users remain responsible for sizing, leverage, entries, and exits.',
  finalCta: {
    eyebrow: 'Next step',
    title: 'Ready for the tighter stream?',
    copy: 'Continue to payment, or start with the free Telegram if you still want to observe first.',
    actions: [
      { label: 'Join VIP', to: '/services/vip/payment' },
      { label: 'Free Telegram', href: 'https://t.me/cryptoxnfts', variant: 'secondary' },
    ],
  },
};

function VIP() {
  return <ServiceDetailPage {...vipConfig} />;
}

export default VIP;
